export default [
    { name: 'YYYY/MM/DD', value: 'fr-ca' },
    { name: 'MM/DD/YYYY', value: 'en' },
    { name: 'DD/MM/YYYY', value: 'fr' },
];
